import {Breadcrumb, Button, Col, ConfigProvider, Dropdown, Empty, Input,  message, Pagination, Row, Table, Tooltip,} from 'antd'
import { DownloadOutlined} from '@ant-design/icons';
import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import css from './case-detail.module.less'
import GlobalCss from '@/global.module.less'
import type { MenuProps } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import SearchInputCom from '@/component/SearchInputCom/SearchInputCom'
import { formatBytesSize } from '@/utils/utils'
import DatasetUploadFileModal from '@/pages/case/components/DatasetUploadFileModal/DatasetUploadFileModal'
import ModalDrag from '@/component/ModaDrag/ModalDrag'
import DatasetUploadZipModal from '@/pages/case/components/DatasetUploadZipModal/DatasetUploadZipModal'
import { sendHttpPostRequest } from '@/api/http-request'
import CopyToClipboard from 'react-copy-to-clipboard'


import { FileAudioViewModal, FileImageViewModal, FileTableViewModal, FileTextViewModal, FileVideoViewModal } from '@/pages/case/components/FileViewModal/FileViewModal'

const items: MenuProps['items'] = [
  {
    key: '1',
    label: <div>添加文件</div>,
  },
  {
    key: '2',
    label: <div>添加文件夹</div>,
  },
]

export const FileList = (props: any) => {
  const { datasetInfo, mode, actionPath, requestType, tabs, dataset_id } = props
  const location = useLocation()
  const state: any = location?.state
  const history = useHistory()
  const orderBy = useRef('')
  const order = useRef('')
  const page = useRef(1)
  const pageSize = useRef(10)
  const queryContent = useRef('')
  const [total, setTotal] = useState(0)
  const [addFileModalVis, setAddFileModalVis] = useState(false)
  const [addZipModalVis, setAddZipModalVis] = useState(false)
  const [actionItem, setActionItem] = useState<any>({})

  const [fileContent, setFileContent] = useState<any>()


  const [deleteFolderModalVis, setDeleteFolderModalVis] = useState(false)
  const [folderFileList, setFolderFileList] = useState([] as any)
  const [copyText, setCopyText] = useState('')
  const copyRef: any = useRef()
  const setCopyRef = (ref) => {
    copyRef.current = ref;
  };

  //预览文件内容相关变量
  const [filePage, setFilePage] = useState(1)
  const [filePageSize, setFilePageSize] = useState(10)
  const [Columns, setColumns] = useState([] as any)
  const [fileTableViewModalVis, setFileTableViewModalVis] = useState(false)
  const [fileImageViewModalVis, setFileImageViewModalVis] = useState(false)
  const [fileTextViewModalVis, setFileTextViewModalVis] = useState(false)
  const [fileVideoViewModalVis, setFileVideoViewModalVis] = useState(false)
  const [fileAudioViewModalVis, setFileAudioViewModalVis] = useState(false)


  const current_path_id = useRef('' as any) //当前目录的path_id

  /*const filePathCurrent = useRef(
    state?.filePath?.length > 1
      ? state?.filePath
      : [
          {
            title: datasetInfo?.title,
            key: datasetInfo?.id,
          },
        ]
  )
  const [filePath, setFilePath] = useState<any[]>(
    state?.filePath?.length > 1
      ? state.filePath.map((f, i) => ({
          title: datasetInfo?.title,
          key: f.key,
        }))
      : [
          {
            key: datasetInfo?.id,
            title: datasetInfo?.title,
          },
        ]
  )*/

  const filePathCurrent = useRef(
    [
          {
            title: datasetInfo?.title,
            key: dataset_id,
          },
        ]
  )
  const [filePath, setFilePath] = useState<any[]>(
   [
          {
            key: dataset_id,
            title: datasetInfo?.title,
          },
        ]
  )

  useEffect(() => {
    current_path_id.current = null
    page.current = 1 
    setFilePath(   [
      {
        key: dataset_id,
        title: datasetInfo?.title,
      },
    ])
      getDatasetFolderInfo()
    return () => {}
  }, [datasetInfo])

  // 向文件夹下操作

  const addFolderFileToRoot = (e) => {
    // setActionItem({})
    // 向根目录 添加文件夹
    if (e.key == '2') {
      // folderFileList.push()
      setFolderFileList([
        {
          key: Math.random() * 1000,
          name: '',
          update_time: '',
          type: 1,
          mode: 'create',
        },
        ...folderFileList,
      ])
    } else if (e.key == '1') {
      // 向根目录 添加文件
      setAddFileModalVis(true)
    }
  }

  const handleBreadCrumbClick = (key?: any, type?: any) => {
    //console.log(key)

    if (type && type == 2) {
      return
    }
    if(key){
      current_path_id.current = key
    }else{
      current_path_id.current = ''
    }
    page.current = 1
    queryContent.current = ''
    if (key) {
      filePath.splice(
        filePath.map((f) => f.key).indexOf(key) + 1,
        filePath?.length - 1
      )

      filePathCurrent.current.splice(
        filePath.map((f) => f.key).indexOf(key) + 1,
        filePath?.length - 1
      )
      setFilePath([...filePath])
    } else {
      filePathCurrent.current = [
        {
          title: datasetInfo?.title,
          key: dataset_id,
        },
      ]
      setFilePath([
        {
          title: datasetInfo?.title,
          key: dataset_id,
        },
      ])
    }

    getDatasetFolderInfo(key ? { path_id: key } : null)

    if(requestType !== 'user'){
      history.push(actionPath || '/oam_dataset_detail/' + dataset_id, {
        ...state,
        filePath: filePathCurrent.current,
      })
    }

  }

  // 查看文件夹文件列表请求
  const getDatasetFolderInfo = (customParams?: any) => {
    let params = {
      path_id: current_path_id.current,
      dataset_id: dataset_id || datasetInfo?.dataset_id,
      page: page.current,
      pagesize: pageSize.current,
      order: order.current,
      order_by: orderBy.current,
      query: queryContent.current,
    }
    if (customParams) {
      params = { ...params, ...customParams }
    }
    if (requestType == 'oam') {
      sendHttpPostRequest(
        'dataset/api/oam_query_dataset_folder/',
        params,
        (res) => {
          if (res.code == 0) {
            setFolderFileList(res.query_list)
            setTotal(res.total_sum)
          } else {
            message.error(res.message)
          }
        }
      )
    } else {
      sendHttpPostRequest(
        'dataset/api/user_query_dataset_folder/',
        params,
        (res) => {
          if (res.code == 0) {
            setFolderFileList(res.query_list)
            setTotal(res.total_sum)
          } else {
            message.error(res.message)
          }
        }
      )
    }
  }

  const handleFolderPreview = (record) => {
    page.current = 1
    queryContent.current = ''
    filePath.push({
      title: record.name,
      key: record.id,
    })
    filePathCurrent.current.push({
      title: record.name,
      key: record.id,
    })
    console.log(filePath, filePathCurrent.current)

    setFilePath([...filePath])
    getDatasetFolderInfo({ path_id: record.id })
    current_path_id.current = record.id
  }

  const fileResponsehandle: any = (type, res) => {

    const cols =
          res.table_content.length > 0
            ? [
                ...Object.keys(res.table_content[0]).map((key, i) => ({
                  title: key,
                  dataIndex: key,
                  key: key,
                })),
              ]
            : []
            
    switch (type) {
      // ? 音频
      case 2:
        setFileContent(res.audio_url)
        setActionItem({
          name: res.file_name,
          type: res.file_type,
          path_id: res.path_id,
          dataset_id: res.dataset_id,
        })
        break
      // ? 图片
      case 3:
        setFileContent(res.image_url)
        setActionItem({
          name: res.file_name,
          type: res.file_type,
          path_id: res.path_id,
          dataset_id: res.dataset_id,
        })
        break
      // ? 视频
      case 4:
        setFileContent(res.video_url)
        setActionItem({
          name: res.file_name,
          type: res.file_type,
          path_id: res.path_id,
          dataset_id: res.dataset_id,
        })
        break
      // ? 表格
      case 5:
        

        setFileContent(res.table_content)
        setActionItem({
          totalSum: res.table_total_samples,
          name: res.file_name,
          type: res.file_type,
          path_id: res.path_id,
          dataset_id: res.dataset_id,
        })
        setColumns([...cols])
        break

      // ? 文本
      case 6:
        setFileContent(res.text_content)
        setActionItem({
          name: res.file_name,
          type: res.file_type,
          path_id: res.path_id,
          dataset_id: res.dataset_id,
        })
        break

      default:
        break
    }
  }
  const fileViewModalOpenHandle = (type) => {
    switch (type) {
      // ? 音频
      case 2:
        setFileAudioViewModalVis(true)
        break
      // ? 图片
      case 3:
        setFileImageViewModalVis(true)
        break
      // ? 视频
      case 4:
        setFileVideoViewModalVis(true)
        break
      //? 表格
      case 5:
        setFileTableViewModalVis(true)
        break
      // ? 文本
      case 6:
        setFileTextViewModalVis(true)
        break
    }
  }

  const download = (res, filename) => {
    // 创建blob对象，解析流数据
    const blob = new Blob([res], {
      // 如何后端没返回下载文件类型，则需要手动设置：type: 'application/pdf;chartset=UTF-8' 表示下载文档为pdf，如果是word则设置为msword，excel为excel
      type: 'application/octet-stream'
    })
    //console.log(blob);
    
    const a = document.createElement('a')
    // 兼容webkix浏览器，处理webkit浏览器中href自动添加blob前缀，默认在浏览器打开而不是下载
    const URL = window.URL || window.webkitURL
    // 根据解析后的blob对象创建URL 对象
    const herf = URL.createObjectURL(blob)
    // 下载链接
    a.href = herf
    // 下载文件名,如果后端没有返回，可以自己写a.download = '文件.pdf'
    a.download = filename
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    // 在内存中移除URL 对象
    window.URL.revokeObjectURL(herf)
  }


  // 获取文件内容
  const getDatasetFileContent = (data) => {
      sendHttpPostRequest(requestType == 'oam'? 'dataset/api/oam_preview_dataset_file/': 'dataset/api/user_preview_dataset_file/', data, (res) => {
        if (res.code == 0) {
          fileResponsehandle(res.file_type, res)
          fileViewModalOpenHandle(res.file_type)
        } else {
          message.error('文件内容查询失败！')
        }
      })
    }
  

  const handleFilePreview = (r) => {
    if (!r.can_view) {
      return
    }
    let data:any = {
      dataset_id: dataset_id,
      path_id: r.id
    }
    if (r.file_type == 5) {
      data = {
        ...data,
        page: filePage,
        pagesize: filePageSize,
      }
    }
    setActionItem(r)
    getDatasetFileContent(data)
  }
  
  


  const fileInputHandle = (record) => {
    let data = {
      dataset_id: datasetInfo?.id,
      path_id: record.id,
      new_name: record.name,
    }
    if (record.name.split('.')[0]?.length <= 0) {
      message.error('文件名称不能为空')
      record.mode = 'view'
      getDatasetFolderInfo(
        filePath?.length > 1
          ? { path_id: filePath[filePath.length - 1].key }
          : null
      )
      return
    }
    if (requestType == 'oam') {
      sendHttpPostRequest(
        'dataset/api/oam_rename_dataset_folder/',
        data,
        (res) => {
          if (res.code == 0) {
            getDatasetFolderInfo(
              filePath?.length > 1
                ? { path_id: filePath[filePath?.length - 1].key }
                : null
            )
          } else {
            message.error(res.message)
          }
        }
      )
    } else {
      sendHttpPostRequest(
        'dataset/api/user_rename_dataset_folder/',
        data,
        (res) => {
          if (res.code == 0) {
            getDatasetFolderInfo(
              filePath?.length > 1
                ? { path_id: filePath[filePath?.length - 1].key }
                : null
            )
          } else {
            message.error(res.message)
          }
        }
      )
    }
  }

  const addDatasetFolder = (record) => {
    if (record.name == '') {
      message.error('文件夹名称不能为空')
      record.mode = 'view'
      getDatasetFolderInfo(
        filePath?.length > 1
          ? { path_id: filePath[filePath?.length - 1].key }
          : null
      )
      return
    }
    let data: any
    if (record.type == 1) {
      data = {
        dataset_id: datasetInfo?.id,
      }
      if (filePath?.length > 1) {
        data = { ...data, parent_path_id: filePath[filePath.length - 1].key }
      }

      if (record.mode === 'create') {
        data = {
          ...data,
          name: record.name,
        }

        if (requestType == 'oam') {
          sendHttpPostRequest(
            'dataset/api/oam_add_dataset_folder/',
            data,
            (res) => {
              if (res.code == 0) {
                getDatasetFolderInfo({
                  path_id:
                    filePath?.length > 1
                      ? filePath[filePath?.length - 1].key
                      : null,
                })
              } else {
                message.error(res.message)
              }
            }
          )
        } else {
          sendHttpPostRequest(
            'dataset/api/user_add_dataset_folder/',
            data,
            (res) => {
              if (res.code == 0) {
                getDatasetFolderInfo({
                  path_id:
                    filePath?.length > 1
                      ? filePath[filePath?.length - 1].key
                      : null,
                })
              } else {
                message.error(res.message)
              }
            }
          )
        }
      } else if (record.mode == 'edit') {
        data = {
          ...data,
          new_name: record.name,
          path_id: record.id,
        }

        if (requestType == 'oam') {
          sendHttpPostRequest(
            'dataset/api/oam_rename_dataset_folder/',
            data,
            (res) => {
              if (res.code == 0) {
                getDatasetFolderInfo({
                  path_id:
                    filePath.length > 1
                      ? filePath[filePath.length - 1].key
                      : null,
                })
              } else {
                message.error(res.message)
              }
            }
          )
        } else {
          sendHttpPostRequest(
            'dataset/api/user_rename_dataset_folder/',
            data,
            (res) => {
              if (res.code == 0) {
                getDatasetFolderInfo({
                  path_id:
                    filePath.length > 1
                      ? filePath[filePath.length - 1].key
                      : null,
                })
              } else {
                message.error(res.message)
              }
            }
          )
        }
      }
    }
  }

  const onFolderFileEdit = (record) => {
    // let data
    record.mode = 'edit'
    setActionItem(record)
    if (record?.mode == 'edit') {
      return
    }
    setActionItem(record)
  }

  const onTableChange = (pag, filters, sorter) => {
    if (sorter.order) {
      order.current = sorter.order
      orderBy.current = sorter.field
    } else {
      order.current = ''
      orderBy.current = ''
    }
    getDatasetFolderInfo({
      path_id: filePath?.length > 1 ? filePath[filePath?.length - 1].key : null,
    })
  }

  const deleteFolderOk = () => {
    if (actionItem?.type == 2) {
      let data = {
        dataset_id: datasetInfo?.id,
        name: actionItem.name,
        path_id: actionItem.id,
      }

      let api_url = 'dataset/api/user_remove_dataset_file/'
      if (requestType == 'oam') {
        api_url = 'dataset/api/oam_remove_dataset_file/'
      }
      sendHttpPostRequest(
        api_url,
        data,
        (res) => {
          if (res.code == 0) {
            // getDatasetInfo()
            message.success('删除成功~')
            getDatasetFolderInfo({
              path_id:
                filePath?.length > 1
                  ? filePath[filePath?.length - 1].key
                  : null,
            })
            setDeleteFolderModalVis(false)
          }
        }
      )
    } else if (actionItem?.type == 1) {
      let data = {
        dataset_id: datasetInfo?.id,
        name: actionItem.name,
        path_id: actionItem.id,
      }
      let api_url = 'dataset/api/user_remove_dataset_folder/'
      if (requestType == 'oam') {
        api_url ='dataset/api/oam_remove_dataset_folder/'
      }

      sendHttpPostRequest(
        api_url,
        data,
        (res) => {
          if (res.code == 0) {
            message.success('删除成功~')
            // getDatasetInfo()
            getDatasetFolderInfo({
              path_id:
                state?.filePath?.length > 1
                  ? state?.filePath[state?.filePath?.length - 1].key
                  : null,
            })
            setDeleteFolderModalVis(false)
          }
        }
      )
    }
  }

  const copyBasePath = (value) => {
    message.success(`复制成功，路径:${value}`)
  }


  const columns_user: any = [
    {
      title: '文件',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: '40%',
      render: (text, record, index) => (
        // record.type == 1 ?
        <div style={{ marginLeft: '8px', display: 'inline-flex' }}>
          <span
            style={{ color: '#3B6D74', marginRight: '8px' }}
            className={
              'iconfont ' +
              (record.type == 1 ? 'icon_wenjianjia' : 'icon_wenjian')
      
            }
          ></span>
          {record?.mode !== 'edit' && record?.mode !== 'create' ? (
            <span
              className={GlobalCss.link + ' ' + GlobalCss.ColFlex}
              onClick={
                record.type == 1
                  ? handleFolderPreview.bind(this, record)
                  : handleFilePreview.bind(this, record)
              }
            >
              <span
                className={GlobalCss.oneLineTextOverflow}
                style={{
                  maxWidth: '360px',
                  display: 'inline-block',
                }}
              >
                {record.name.split('.').length > 1
                  ? record.name
                      .split('.')
                      .slice(0, record.name.split('.').length - 1)
                      .join()
                  : record.name}
              </span>
              {record.name.split('.').length > 1 && (
                <span>
                  {'.' +
                    record.name.split('.')[record.name.split('.')?.length - 1]}
                </span>
              )}
            </span>
          ) : record.type == 2 ? (
            <Row justify={'center'} align={'middle'} wrap={false}>
              <Input
                autoFocus
                value={record.name.split('.')[0]}
                onChange={(e) => {
                  if (record.name.split('.')?.length > 1) {
                    record.name =
                      e.target.value +
                      '.' +
                      record.name.split('.')[record.name.split('.')?.length - 1]
                    setFolderFileList([...folderFileList])
                  } else {
                    record.name = e.target.value
                  }
                }}
                onBlur={fileInputHandle.bind(this, record)}
                onPressEnter={fileInputHandle.bind(this, record)}
              />
              {record.type == 1 && record.name.split('.')?.length <= 1
                ? ''
                : '.' +
                  record.name.split('.')[record.name.split('.')?.length - 1]}
            </Row>
          ) : (
            <Input
              autoFocus
              value={record.name}
              onChange={(e) => {
                record.name = e.target.value
                setFolderFileList([...folderFileList])
              }}
              onBlur={addDatasetFolder.bind(this, record)}
              onPressEnter={addDatasetFolder.bind(this, record)}
            />
          )}
        </div>
      ),
    },
    {
      title: '大小',
      dataIndex: 'size',
      key: 'size',
      ellipsis: true,
      align: 'center',
      width: '20%',
      render: (t, r, i) => {
        return t == 0 ? '--' : <span>{formatBytesSize(t - 0)}</span>
      },
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: '20%',
      ellipsis: true,
      align: 'center',
      key: 'action',
      render: (text, record, index) => {
        return (
          <div
            className={GlobalCss.ColFlex}
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            {record.type == 1 ? (
              <Tooltip title={'预览文件夹'} placement="top">
                <div
                  className={GlobalCss.btnBox}
                  onClick={handleFolderPreview.bind(this, record)}
                >
                  <span
                    style={
                      record?.mode == 'edit' || record?.mode == 'create'
                        ? {
                            color: '#bbbbbb',
                            fontSize: '18px',
                            cursor: 'not-allowed',
                          }
                        : {
                            color: '#3B6D74',
                            fontSize: '18px',
                          }
                    }
                    className="iconfont icon_xianshibiaoji"
                  ></span>
                </div>
              </Tooltip>
            ) : (
              <Tooltip title={'查看文件'} placement="top">
                <div
                  className={GlobalCss.btnBox}
                  onClick={handleFilePreview.bind(this, record)}
                >
                  <span
                    style={
                      record?.can_view
                        ? {
                            color: '#3B6D74',
                            fontSize: '18px',
                          }
                        : {
                            color: '#bbbbbb',
                            fontSize: '18px',
                            cursor: 'not-allowed',
                          }
                    }
                    className="iconfont icon_xianshibiaoji"
                  ></span>
                </div>
              </Tooltip>
            )}

            {mode !== 'monted' && requestType !== 'user' && (
              <Tooltip placement="top" title={'重命名'}>
                <div
                  className={GlobalCss.btnBox}
                  onClick={onFolderFileEdit.bind(this, record)}
                >
                  <span
                    style={
                      record?.mode == 'edit' || record?.mode == 'create'
                        ? {
                            color: '#bbbbbb',
                            fontSize: '18px',
                            cursor: 'not-allowed',
                          }
                        : { color: '#3B6D74', fontSize: '18px' }
                    }
                    className={'iconfont icon_zhongmingming'}
                  ></span>
                </div>
              </Tooltip>
            )}

         
              <Tooltip placement="top" title={'下载'}>
                <div
                  className={GlobalCss.btnBox}
                  onClick={() => {
                    if(record?.type !== 1) {
    
                      setActionItem(record)

                      if (record?.size >= 1024 * 1024 * 500) {
                        message.info("抱歉当前不支持500M以上文件下载！")
                      }else {
                        sendHttpPostRequest(
                          requestType == 'user' ? "dataset/api/user_download_datasetfile/" : 'dataset/api/oam_download_datasetfile/',
                          {dataset_id:  dataset_id || datasetInfo?.dataset_id,
                            path_id:record?.id},
                          (res) => {
                            download(res, record?.name)
                          },
                          { responseType: 'blob' }
                        )
                      }

                    }

                  }}
                >
                  <span
                    style={
                      record?.type == 1  //文件夹
                        ? {
                            color: '#bbbbbb',
                            fontSize: '18px',
                            cursor: 'not-allowed',
                          }
                        : { color: '#3B6D74', fontSize: '18px' }
                    }
                   
                  ><DownloadOutlined style={{fontSize:13}}/></span>
                </div>
              </Tooltip>
            

            { mode !== 'monted'  && requestType !== 'user' && (
              <Tooltip placement="top" title={'删除'}>
                <div
                  className={GlobalCss.btnBox}
                  onClick={() => {
                    setActionItem(record)
                    setDeleteFolderModalVis(true)
                  }}
                >
                  <span
                    style={
                      record?.mode == 'edit' || record?.mode == 'create'
                        ? {
                            color: '#bbbbbb',
                            fontSize: '18px',
                            cursor: 'not-allowed',
                          }
                        : { color: '#e50314', fontSize: '20px' }
                    }
                    className="iconfont icon_shanchu-20"
                  ></span>
                </div>
              </Tooltip>
            )}
          </div>
        )
      },
    },
  ]

  const columns: any = [
    {
      title: '文件',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: '40%',
      render: (text, record, index) => (
        <div style={{ marginLeft: '8px', display: 'inline-flex' }}>
          <span
            style={{ color: '#07C160', marginRight: '8px' }}
            className={
              'iconfont ' +
              (record.type == 1 ? 'icon_wenjianjia' : 'icon_wenjian')
            }
          ></span>
          {record?.mode !== 'edit' && record?.mode !== 'create' ? (
            <span
              className={GlobalCss.link + ' ' + GlobalCss.ColFlex}
              onClick={
                record.type == 1
                  ? handleFolderPreview.bind(this, record)
                  : () => false
              }
            >
              <span
                className={GlobalCss.oneLineTextOverflow}
                style={{
                  maxWidth: '320px',
                  display: 'inline-block',
                }}
                title={record.name}
              >
                {record.name.split('.').length > 1
                  ? record.name
                      .split('.')
                      .slice(0, record.name.split('.').length - 1)
                      .join()
                  : record.name}
              </span>
              {record.name.split('.').length > 1 && (
                <span>
                  {'.' +
                    record.name.split('.')[record.name.split('.')?.length - 1]}
                </span>
              )}
            </span>
          ) : record.type == 2 ? (
            <Row justify={'center'} align={'middle'} wrap={false}>
              <Input
                autoFocus
                value={record.name.split('.')[0]}
                onChange={(e) => {
                  if (record.name.split('.')?.length > 1) {
                    record.name =
                      e.target.value +
                      '.' +
                      record.name.split('.')[record.name.split('.')?.length - 1]
                    setFolderFileList([...folderFileList])
                  } else {
                    record.name = e.target.value
                  }
                }}
                onBlur={fileInputHandle.bind(this, record)}
                onPressEnter={fileInputHandle.bind(this, record)}
              />
              {record.type == 1 && record.name.split('.')?.length <= 1
                ? ''
                : '.' +
                  record.name.split('.')[record.name.split('.')?.length - 1]}
            </Row>
          ) : (
            <Input
              autoFocus
              value={record.name}
              onChange={(e) => {
                record.name = e.target.value
                setFolderFileList([...folderFileList])
              }}
              onBlur={addDatasetFolder.bind(this, record)}
              onPressEnter={addDatasetFolder.bind(this, record)}
            />
          )}
        </div>
      ),
    },
    {
      title: '大小',
      dataIndex: 'size',
      key: 'size',
      align: 'center',
      width: '20%',
      render: (t, r, i) => {
        return t == 0 ? '--' : <span>{formatBytesSize(t - 0)}</span>
      },
    },
    {
      title: '更新时间',
      dataIndex: 'update_time',
      key: 'update_time',
      align: 'center',
      width: '180px',
      sorter: true,
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: '20%',
      align: 'center',
      key: 'action',
      fixed: 'right',
      render: (text, record, index) => {
        return (
          <div
            className={GlobalCss.ColFlex}
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            {record.type == 1 ? (
              <Tooltip title={'预览文件夹'} placement="top">
                <div
                  className={GlobalCss.btnBox}
                  onClick={handleFolderPreview.bind(this, record)}
                >
                  <span
                    style={
                      record?.mode == 'edit' || record?.mode == 'create'
                        ? {
                            color: '#bbbbbb',
                            fontSize: '18px',
                            cursor: 'not-allowed',
                          }
                        : {
                            color: '#07C160',
                            fontSize: '18px',
                          }
                    }
                    className="iconfont icon_xianshibiaoji"
                  ></span>
                </div>
              </Tooltip>
            ) : (
              <Tooltip title={'查看文件'} placement="top">
                <div
                  className={GlobalCss.btnBox}
                  // onClick={handleFilePreview.bind(this, record)}
                >
                  <span
                    style={
                      record?.can_view
                        ? {
                            color: '#07C160',
                            fontSize: '18px',
                          }
                        : {
                            color: '#bbbbbb',
                            fontSize: '18px',
                            cursor: 'not-allowed',
                          }
                    }
                    className="iconfont icon_xianshibiaoji"
                  ></span>
                </div>
              </Tooltip>
            )}

            {mode !== 'monted' && (
              <Tooltip placement="top" title={'重命名'}>
                <div
                  className={GlobalCss.btnBox}
                  onClick={onFolderFileEdit.bind(this, record)}
                >
                  <span
                    style={
                      record?.mode == 'edit' || record?.mode == 'create'
                        ? {
                            color: '#bbbbbb',
                            fontSize: '18px',
                            cursor: 'not-allowed',
                          }
                        : { color: '#07C160', fontSize: '18px' }
                    }
                    className={'iconfont icon_zhongmingming'}
                  ></span>
                </div>
              </Tooltip>
            )}
            <Tooltip placement="top" title={'复制数据集路径'}>
              <div
                className={GlobalCss.btnBox}
                onClick={() => {
                  let data = {
                    path_id: record?.id,
                    dataset_id: datasetInfo?.id || datasetInfo?.dataset_id,
                  }
                  sendHttpPostRequest(
                    'dataset/api/user_get_dataset_file_visite_path/',
                    data,
                    (res) => {
                      if (res.code == 0) {
                        setCopyText(res.visited_path)
                        console.log(copyRef)
                        copyRef.current?.onClick()
                      }
                    }
                  )
                }}
                // onClick={onFolderFileEdit.bind(this, record)}
              >
                <span
                  style={{ color: '#4285F4', fontSize: '18px' }}
                  className={'iconfont icon_fuzhi'}
                ></span>
                <CopyToClipboard
                  ref={setCopyRef}
                  text={copyText}
                  onCopy={() => copyBasePath(copyText)}
                >
                  <div></div>
                </CopyToClipboard>
              </div>
            </Tooltip>

                     
            <Tooltip placement="top" title={'下载'}>
                <div
                  className={GlobalCss.btnBox}
                  onClick={() => {
                    if(record?.type !== 1) {
    
                      setActionItem(record)

                      if (record?.size >= 1024 * 1024 * 500) {
                        message.info("抱歉当前不支持500M以上文件下载！")
                      }else {
                        sendHttpPostRequest(
                          requestType == 'user' ? "dataset/api/user_download_datasetfile/" : 'dataset/api/oam_download_datasetfile/',
                          {dataset_id:  dataset_id || datasetInfo?.dataset_id,
                            path_id:record?.id},
                          (res) => {
                            download(res, record?.name)
                          },
                          { responseType: 'blob' }
                        )
                      }

                    }

                  }}
                >
                  <span
                    style={
                      record?.type == 1  //文件夹
                        ? {
                            color: '#bbbbbb',
                            fontSize: '18px',
                            cursor: 'not-allowed',
                          }
                        : { color: '#3B6D74', fontSize: '18px' }
                    }
                   
                  ><DownloadOutlined style={{fontSize:13}}/></span>
                </div>
              </Tooltip>
              
            {mode !== 'monted' && (
              <Tooltip placement="top" title={'删除'}>
                <div
                  className={GlobalCss.btnBox}
                  onClick={() => {
                    setActionItem(record)
                    setDeleteFolderModalVis(true)
                  }}
                >
                  <span
                    style={
                      record?.mode == 'edit' || record?.mode == 'create'
                        ? {
                            color: '#bbbbbb',
                            fontSize: '18px',
                            cursor: 'not-allowed',
                          }
                        : { color: '#e50314', fontSize: '20px' }
                    }
                    className="iconfont icon_shanchu-20"
                  ></span>
                </div>
              </Tooltip>
            )}
          </div>
        )
      },
    },
    // : {},
  ]

  const deleteFolderModalContent = (
    <div style={{ margin: '0 auto' }}>
      <Row align={'middle'} justify={'center'} style={{ width: '100%' }}>
        <Col>
          确定要删除
          <span className={GlobalCss.hlText}> {actionItem?.name} </span>
          吗？
        </Col>
      </Row>
      {actionItem?.type == 1 && (
        <Row align={'middle'} justify={'center'} style={{ width: '100%' }}>
          <Col>删除后该文件夹中所有的文件将无法恢复。</Col>
        </Row>
      )}
    </div>
  )

  return (
    <div>
      <Row
        align={'middle'}
        justify={'space-between'}
        style={{ minHeight: (tabs == 'run'? '0px' : '36px'),flexWrap: 'nowrap',  overflow: 'hidden' }}
      >
        <Col className={css.breadContain}>
          {filePath && filePath?.length > 1 && (
            <Breadcrumb>
              {filePath?.map((file, i) => {
                return (
                  <Breadcrumb.Item
                    className={GlobalCss.link}
                    onClick={() => {
                      if (i == filePath.length - 1) {
                        return
                      } else {
                        handleBreadCrumbClick(i > 0 ? file.key : null)
                      }
                    }}
                    key={file.key}
                  >
                    {file.title}
                  </Breadcrumb.Item>
                )
              })}
            </Breadcrumb>
          )}
        </Col>
        <Col className={GlobalCss.ColFlex + ' ' + (tabs == 'run'? css.tabs : '')} style={{ gap: '10px' }}>
          {requestType=='oam' && datasetInfo?.dataset_type == 1 &&( //oam 习题数据集
            <span
            style={{lineHeight:'32px'}}
              className={GlobalCss.link + ' ' + GlobalCss.hlText}
              onClick={() =>
                window.open(
                  '/oam_exercise_edit?exercise_id=' + datasetInfo?.exercise_id
                )
              }
            >
              {datasetInfo?.exercise_name}
              {'>'}
            </span>
          )}

        {requestType=='oam' &&  datasetInfo?.dataset_type == 3 && ( //oam 实验数据集
            <span
              style={{lineHeight: '32px'}}
              className={GlobalCss.link + ' ' + GlobalCss.hlText}
              onClick={() =>
                window.open('/oam-case-preview?case_id=' + datasetInfo?.case_id )
              }
            >
              {datasetInfo?.case_name}
              {'>'}
            </span>
          )}

          <SearchInputCom
            placeholder="请输入文件名称搜索"
            onChange={(e) => {
              queryContent.current = e.target.value
            }}
            onSearch={() => {
              page.current = 1
              getDatasetFolderInfo(
                state?.filePath
                  ? {
                      path_id:
                        state?.filePath?.length > 1
                          ? state?.filePath[state?.filePath?.length - 1].key
                          : null,
                    }
                  : {}
              )
            }}
            width={220}
          />

          {mode !== 'monted' && (
            <Dropdown
              menu={{ items, onClick: addFolderFileToRoot }}
              placement="bottom"
              arrow={{ pointAtCenter: true }}
            >
              <Button className={GlobalCss.defBtn}>添加文件</Button>
            </Dropdown>
          )}
        </Col>
      </Row>
      {filePath?.length <= 1 && folderFileList?.length <= 0 ? (
        <div
          style={{
            width: '100%',
            height: '500px',
            lineHeight: '500px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: (tabs == 'run'? '-20px' : '0px'),
          }}
        >
          {queryContent.current == '' && !actionPath ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <span style={{ color: '#999999' }}>
                  暂无数据 ，点击
                  <span
                    onClick={() => setAddZipModalVis(true)}
                    className={GlobalCss.link + ' ' + GlobalCss.hlText}
                  >
                    上传压缩包
                  </span>
                </span>
              }
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <span style={{ color: '#999999' }}>
                  暂无数据
                  {/* ，点击
                  <span
                    onClick={() => setAddZipModalVis(true)}
                    className={GlobalCss.link + ' ' + GlobalCss.hlText}
                  >
                    上传压缩包
                  </span> */}
                </span>
              }
            />
          )}
        </div>
      ) : (
        <div
          className={css.tableTreeWapper+' '+(tabs == 'run'? '': css.tableTreeWapperelse)}
          style={{ minHeight: '450px', width: '100%' }}
        >
          <ConfigProvider locale={zhCN}>
            <Table
              scroll={{x: 500 }}
              columns={ requestType == 'user' ? columns_user: columns}
              dataSource={folderFileList}
              pagination={false}
              onChange={onTableChange}
            />
          </ConfigProvider>
        </div>
      )}
      <div
        className={GlobalCss.pagination}
        style={{ textAlign: 'center', marginTop: '20px' }}
      >
        <ConfigProvider locale={zhCN}>
          <Pagination
            onChange={(nPage, nPageSize) => {
              page.current = nPage
              pageSize.current = nPageSize
              getDatasetFolderInfo({
                path_id:
                  filePath?.length > 1
                    ? filePath[filePath?.length - 1].key
                    : null,
              })
            }}
            pageSize={pageSize.current}
            hideOnSinglePage
            current={page.current}
            total={total}
          />
        </ConfigProvider>
      </div>
      <DatasetUploadFileModal
        uploadType={'dataset_file'}
        open={addFileModalVis}
        // mode={mode}
        setOpen={setAddFileModalVis}
        actionCallback={() =>
          getDatasetFolderInfo({
            path_id:
              filePath?.length > 1 ? filePath[filePath?.length - 1].key : null,
          })
        }
        basePath={
          filePath?.length > 1 ? filePath[filePath?.length - 1].key : null
        }
        apiUrl={
          requestType == 'oam'?
          'dataset/api/oam_add_dataset_file_by_upload/': 'dataset/api/user_add_dataset_file_by_upload/'
        }
        uploadDataProps={{
          dataset_id: datasetInfo?.id || datasetInfo?.dataset_id,
        }}
      />


      <FileTableViewModal
          open={fileTableViewModalVis}
          setOpen={setFileTableViewModalVis}
          fileInfo={actionItem}
          fileContent={fileContent}
          Columns={Columns}
          page={filePage}
          pageSize={filePageSize}
          setPage={setFilePage}
          setPageSize={setFilePageSize}
          actionCallback={getDatasetFileContent}
        />
        {actionItem.type == 3 && (
          <FileImageViewModal
            open={fileImageViewModalVis}
            setOpen={setFileImageViewModalVis}
            fileContent={fileContent}
          />
        )}
        <FileTextViewModal
          fileInfo={actionItem}
          fileContent={fileContent}
          open={fileTextViewModalVis}
          setOpen={setFileTextViewModalVis}
        />
        <FileVideoViewModal
          fileInfo={actionItem}
          fileContent={fileContent}
          open={fileVideoViewModalVis}
          setOpen={setFileVideoViewModalVis}
        />
        <FileAudioViewModal
          fileInfo={actionItem}
          fileContent={fileContent}
          open={fileAudioViewModalVis}
          setOpen={setFileAudioViewModalVis}
        />

      <ModalDrag
        modalTitle={'删除'}
        modalContent={deleteFolderModalContent}
        open={deleteFolderModalVis}
        onOk={deleteFolderOk}
        onCancel={() => {
          setDeleteFolderModalVis(false)
        }}
        bodyStyle={{
          height: '130px',
          padding: '0px 60px',
          display: 'flex',
          alignItems: 'center',
        }}
        width={460}
      />
      <DatasetUploadZipModal
        uploadType={'dataset_zip'}
        open={addZipModalVis}
        setOpen={setAddZipModalVis}
        actionCallback={() =>
          getDatasetFolderInfo({
            path_id:
              filePath?.length > 1 ? filePath[filePath?.length - 1].key : null,
          })
        }
        apiUrl={requestType == 'oam'? 'dataset/api/oam_upload_dataset_zip/' : 'dataset/api/user_upload_dataset_zip/'}
        uploadDataProps={{ dataset_id: datasetInfo?.id }}
      />
    </div>
  )
}
